import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { CoachListData, CoachListPayload, VehicleLayout } from '@/new-transport/_models/transport-coach-list.model';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class TransportCoachListApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getCoachList(transportId: number, reassignAll: boolean, copyFromDeparture: boolean): Observable<CoachListData[]> {
		return this.httpClient.get<CoachListData[]>(
			`${this.apiUrl}/transport/${transportId}/slots_for_coach_list/?reassign_all=${reassignAll}&copy_from_departure=${copyFromDeparture}`,
		);
	}

	getLayouts(): Observable<Result<VehicleLayout>> {
		return this.httpClient.get<Result<VehicleLayout>>(`${this.apiUrl}/transport/layout/`);
	}

	updateCoachList(payload: CoachListPayload[]): Observable<void> {
		return this.httpClient.put<void>(`${this.apiUrl}/reservation/offer/slot/update_slot_vehicles/`, payload);
	}

	generateTransportList(id: number): Observable<string> {
		return this.httpClient.get<string>(`${environment.apiUrl}/transport/${id}/generate_coach_list/`);
	}
}
